import styled from 'styled-components';
import { SIZE } from 'assets/styles/ScreenSize';
import { COLORS } from 'utils/styles/colors';
import { FONT_FAMILY, FONTS } from 'utils/styles/fonts';
import { FLEX_CONTAINER } from 'utils/styles/flex';

export const PrivacyPolicyWrapper = styled.div`
  ${FLEX_CONTAINER.FlexColumn};
  align-items: unset;
  gap: 20px;
  width: 100%;
  margin-top: 60px;
  padding: 20px 286px 100px;
  
  @media only screen and (max-width: ${SIZE.bigDesktop}){
    padding-left: 134px;
    padding-right: 134px;
  }
  
  @media only screen and (max-width: ${SIZE.desktop}){
    padding-left: 80px;
    padding-right: 80px;
  }
  
  @media only screen and (max-width: ${SIZE.tablet}){
    padding-left: 40px;
    padding-right: 40px;
  }

  @media only screen and (max-width: ${SIZE.iphone}){
    padding-left: 20px;
    padding-right: 20px;
   }
`;

export const TitlePage = styled.span`
  ${FONT_FAMILY.FontBold};
  ${FONTS.font24};
  color: ${COLORS.mainColor};
  text-transform: capitalize;

  @media only screen and (max-width: ${SIZE.bigDesktop}){
    ${FONTS.font20};
  }

  @media only screen and (max-width: ${SIZE.desktop}){
    ${FONTS.font16};
  }
`;

export const PrivacyRuleText = styled.span`
  ${FONT_FAMILY.FontRegular};
  ${FONTS.font16};
  color: ${COLORS.mainColor};
  
  @media only screen and (max-width: ${SIZE.tablet}){
    ${FONTS.font12};
  }
`;

export const TitleSection = styled.span`
  ${FONT_FAMILY.FontSemiBold};
  ${FONTS.font16};
  color: ${COLORS.mainColor};

  @media only screen and (max-width: ${SIZE.tablet}){
    ${FONTS.font14};
  }
`;

export const SectionList = styled.li`
  color: ${COLORS.mainColor};
`;
